import React, { FC, ReactNode } from 'react'

type ExternalLinkProps = {
  href: string
  title: string
  children: ReactNode
}

/**
 * Renders a simple external link wrapper that opens in a new tab.
 */
const ExternalLink: FC<ExternalLinkProps> = props => (
  <a
    title={props.title}
    href={props.href}
    rel="noopener noreferrer"
    target="_blank">
    {props.children}
  </a>
)

export { ExternalLink }
